import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { ModalService } from '@fino-ui/modal';
import { ApproveModalComponent } from '../../../components/approve-modal/approve-modal.component';

@Component({
  selector: 'app-unlock-transaction-list',
  templateUrl: './unlock-transaction-list.component.html',
  imports: [ButtonModule],
})
export class UnlockTransactionListComponent {
  private readonly modalService = inject(ModalService);

  @Output()
  public unlockList = new EventEmitter();

  readonly isLoading = input<boolean>(false);

  openSubmitModal() {
    this.modalService
      .addModal<boolean>(ApproveModalComponent, {
        title: 'captureTransaction.unlock.title',
        description: 'captureTransaction.unlock.description',
      })
      .subscribe((approved) => {
        if (approved) this.unlockList.emit(true);
      });
  }
}
